import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/panel/app/components/ChunkLoadRecovery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmployeeProvider"] */ "/srv/panel/app/contexts/EmployeeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/srv/panel/app/contexts/UserContext.tsx");
;
import(/* webpackMode: "eager" */ "/srv/panel/node_modules/.pnpm/next@15.5.26_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/srv/panel/app/styles/theme-palette.css");
;
import(/* webpackMode: "eager" */ "/srv/panel/app/styles/theme-bayer.css");
;
import(/* webpackMode: "eager" */ "/srv/panel/app/globals.css");
;
import(/* webpackMode: "eager" */ "/srv/panel/node_modules/.pnpm/@fortawesome+fontawesome-free@6.7.2/node_modules/@fortawesome/fontawesome-free/css/all.min.css");
